import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "products-list" }
const _hoisted_2 = {
  key: 0,
  class: "products-list__loader"
}
const _hoisted_3 = {
  key: 1,
  class: "products-list__empty"
}
const _hoisted_4 = {
  key: 2,
  class: "products-list__items"
}

import { PropType } from 'vue';
import AppLoader from '@/components/AppLoader.vue';
import ProductCard from '@/components/ProductCard.vue';
import { Product } from '@/types/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsList',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
  products: {
    type: Array as PropType<Product[]>,
    default: [] as Product[],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppLoader)
        ]))
      : (__props.products.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('emptyRequestResult')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
              return (_openBlock(), _createBlock(ProductCard, {
                key: product.productId,
                product: product
              }, null, 8, ["product"]))
            }), 128))
          ]))
  ]))
}
}

})